import ccEcharts from '@/components/common/echarts/echarts-base.vue';
// import echarts from 'echarts';
import 'echarts/map/js/world';
import dataList from './dataList';
export default {
    name: 'world-map-echarts',
    components: {ccEcharts},
    props: {
        id: {
            type: String,
            default: ''
        },
        data:{
            type:Array,
            default() {
                return [];
            }
        }
    },
    watch: {
        data: {
            deep: true,
            handler: function (val) {
                this.echartsData = val;
                this.handleData();
            }
        }
    },
    data() {
        return {
            options:{
                tooltip: {
                    show: true,
                    backgroundColor:'transparent',
                    padding:0,
                    formatter: function (params) {
                        const data = params.data;
                        let tag;
                        if (data && data.title) {
                            let formatterVal = "<div class='fd-map-tooltip-01'>";
                            formatterVal += `<p class='fd-map-title'>${data.title}</p>`;
                            // formatterVal += `<p class='fd-map-title'>${params.name}</p>`;
                            const xs = data.xs === tag ? '' : `新收<span>${data.xs}<em>件</em></span>`;
                            const jc = data.jc === tag ? '' : `旧存<span>${data.jc}<em>件</em></span>`;
                            const yj = data.yj === tag ? '' : `结案<span>${data.yj}<em>件</em></span>`;
                            const wj = data.wj === tag ? '' : `未结<span>${data.wj}<em>件</em></span>`;
                            formatterVal += `<p class='fd-map-text'>${xs}${jc}${yj}${wj}</p>`;
                            return formatterVal;
                        }
                    }
                },
                visualMap: {
                    show: false,
                    max: 100,
                    seriesIndex: [0],
                    inRange: {color: ['#8cbbfc', '#5089ff']}
                },
                geo: {
                    map: 'world',
                    show: true,
                    roam: false,
                    zoom:1.2,
                    label: {emphasis: {show: false}},
                    itemStyle: {normal: {borderWidth: 0}}
                },
                series: [
                    {
                        type: 'map',
                        map: 'world',
                        geoIndex: -1,
                        zoom:1.2,
                        label: {
                            normal: {
                                show: true,
                                color:'#000',
                                padding:[30, 0, 0, 0],
                                fontSize:12,
                                formatter:function () {
                                    return '';
                                }
                            },
                            emphasis: {
                                show: false,
                                color:'#25446b'
                            }
                        },
                        itemStyle: {
                            normal: {
                                areaColor: '#8cbbfc',
                                borderColor: '#fff',
                                borderWidth: 1
                            },
                            emphasis: {
                                areaColor: '#cce3ff',
                                borderColor: '#fff',
                                borderWidth: 1
                            }
                        },
                        data: [],
                        z:1
                    },
                    {
                        type: 'scatter',
                        coordinateSystem: 'geo',
                        label: {normal: {show: false}},
                        symbol: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAAGzVWdFAAAAAXNSR0IArs4c6QAAAERlWElmTU' +
                            '0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAB6ADAAQAAAABAAAABwAAAADRVt9WAAAAbElEQVQIHW2N0RF' +
                            'AQAxENxmtUIES+HIF6AF9XQG6oBzfF9kwwwz3kU3ebi4AX9PPm7CYWRsTqdTdZCKyPxapA7oR4w57jy6DoGSDjhVQViN21dC7+KBJgCOUO4y8E1evSfnZ1/BLzp' +
                            'VX/kzyE/cSJudyGq7SAAAAAElFTkSuQmCC',
                        symbolSize: [7, 7],
                        z: 2,
                        zoom:1.2,
                        data: []
                    }]
            },
            echartsData:this.data
        };
    },
    mounted() {
        this.handleData();
    },
    methods: {
        // 处理options的data
        handleData() {
            this.initOptions();
        },
        // 处理options
        initOptions() {
            // 处理地图数据
            this.echartsData = this.sort(this.echartsData);
            const sortData = this.echartsData.slice(0, 10);
            const _index = sortData.findIndex((item) => item.name === '未知');
            if (_index > -1) {
                sortData.push(this.echartsData[10]);
            }
            // 设置option
            this.options.series[0].data = this.convertData();
            this.options.series[1].data = this.convertData(sortData);
            // 处理文字的显示
            sortData.forEach(item => {
                item.eName = dataList.mapName[item.name];
            });
            this.options.series[0].label.normal.formatter = function (params) {
                const index = sortData.findIndex(item => item.eName === params.name);
                if (index !== -1) {
                    return sortData[index].name;
                    // return params.name
                }
                return '';
            };
        },
        // 组合点
        convertData(data) {
            const _this = this;
            const res = [];
            // 如果展示点点的
            if (data) {
                for (let i = 0; i < this.echartsData.length; i++) {
                    const geoCoord = dataList.geoCoordMap[this.echartsData[i].name];
                    if (geoCoord) {
                        const item = _this.echartsData[i];
                        const resItem = {
                            ...item,
                            cName:this.echartsData[i].name,
                            name: dataList.mapName[this.echartsData[i].name],
                            value: geoCoord.concat(this.echartsData[i].value)
                        };
                        res.push(resItem);
                    }
                }
            } else {
                // 如果不是展示点点
                for (const key in dataList.geoCoordMap) {
                    // 如果是从外面传过来的数据，就是有数据的
                    const _index = _this.echartsData.findIndex(item => item.name === key);
                    if (_index !== -1) {
                        const item = _this.echartsData[_index];
                        const resItem = {
                            ...item,
                            cName:key,
                            name: dataList.mapName[key],
                            value:100
                        };
                        res.push(resItem);
                    } else {
                        // 没有数据的
                        res.push({
                            cName:key,
                            name: dataList.mapName[key],
                            value:0
                        });
                    }
                }
            }
            return res;
        },
        // 排序
        sort(data) {
            let sortData = [...data];
            sortData = sortData.sort(function (a, b) {
                return b.xs - a.xs;
            });
            return sortData;
        }
    }
};
